import { cn } from '@/shared/lib/utils'

export function CallsignRail({ callsign, className }: { callsign: string; className?: string }) {
  return (
    <span
      className={cn(
        'flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-lg bg-brand-accent-soft font-mono text-[11.5px] font-semibold tabular-nums text-brand-accent-ink',
        className,
      )}
    >
      {callsign}
    </span>
  )
}
